import { SearchForm, DetailInfo } from '@/types/Syain'
import { defineStore } from 'pinia'
import { UserApi } from '@/api/UserApi'
import { Permission, Role } from '@/types/Permissions'

export const useSyainStore = defineStore('syain', {
  state: () => {
    return {
      item: {
        kana: null as null | string,
        syozokuId: null as null | number,
        shikaku: null as null | string,
        mst_role_id: null as null | number,
      },
    }
  },
  actions: {
    // 検索条件のセット
    setItem(searchItem: SearchForm) {
      this.item = searchItem
    },
    // 検索条件のクリア
    removeItem() {
      this.item = {
        kana: null,
        syozokuId: null,
        shikaku: null,
        mst_role_id: null,
      };
    },
  },
  getters: {
    searchItem(): SearchForm {
      return this.item
    },
  }
})